function syncNewData(elementId, newData) {
  const accountInfo = document.getElementById(elementId);

  if (!accountInfo) return;

  const nameField = accountInfo.querySelector('#name');
  const phoneField = accountInfo.querySelector('#phone');
  const formattedName = `${newData.first_name} ${newData.last_name}`;
  const formattedPhone = newData.phone ? newData.phone.replace(/^\+66/, '0') : '-'

  nameField.textContent = formattedName;
  phoneField.textContent = formattedPhone;
}

function syncDataFormat(member) {
  const memberNo = member?.memberNo || member?.member_no;

  return ({
    customer: {
      first_name: member.firstNameTh || member.firstNameEn,
      last_name: member.lastNameTh || member.lastNameEn,
      phone: member.phone.startsWith('0') ? `+66${member.phone.slice(1)}` : member.phone,
      metafields: memberNo ? [{
        namespace: "custom",
        key: "member_no",
        value: memberNo,
        type: "single_line_text_field"
      }] : undefined
    }
  })
}